import $ from 'jquery'
window.jQuery = window.$ = $; 

jQuery(document).ready(function ($) { 

  new Glide('.glide',{
    gap: 0,
    autoplay: 5000,
    animationDuration: 1000}).mount()


});
